module.exports = __webpack_public_path__ + "fonts/aveny-tinstagram-medium-webfont.adbc044b.ttf";